import React from "react";
import moment from "moment";
import { Badge } from 'reactstrap';
import SessionNotes from "./SessionNotes";
import { getPatientMonthlyPhoneConsultationBy } from "./pmSessionConsultation.helpers";
const _ = require("lodash");

function CPTCodeList(props) {
    const { CPTCodeDetails, rpmMode, totalSessionRPM, totalSessionCCM, ccmMode } = props;
    // code model generater check
    const codeModel = CPTCodeDetails && CPTCodeDetails.codeModel;
    // cpt code 99453 tables rows value
    const code99453 = CPTCodeDetails.verbalConsentAndWelcomeCompleteNote && CPTCodeDetails.verbalConsentAndWelcomeCompleteNote.map((note) => {
    return (
        <tr>
          <td>{note.subject  ? note.subject : '-'}</td>
          <td>{note.body  ? note.body : '-'}</td>
          <td>{note.createdBy ? note.createdBy.lname + " " + note.createdBy.fname : "-"}</td>
          <td>{moment(note.createdAt).format("MM/DD/YYYY")}</td>
          <td className="text-center">{CPTCodeDetails.isEligible99453 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
        </tr>
      );
    })
    //  cpt code 99454 tables rows value
    const code99454 =  (
        <tr>
          <td>{CPTCodeDetails.adhenrenceDay}</td>
          <td>{CPTCodeDetails.isEligible99454 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
        </tr>
      );
      //  cpt code 99445 tables rows value
      const code99445 = (
        <tr>
          <td>{CPTCodeDetails.adhenrenceDay}</td>
          <td>{CPTCodeDetails.isEligible99445 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
        </tr>
      );
      const code99470 =  (
        <tr>
          <td>{codeModel.cpt99470 && codeModel.cpt99470.length > 0 ? _.map(codeModel.cpt99470, (value, index) => ( <Badge color="warning" pill outline key={index} className="mr-2"> 99470 </Badge> ))  : '-'}</td>
          <td>{totalSessionRPM}</td>
          <td>{codeModel && _.size(codeModel.cpt99470) > 0 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
        </tr>
      );
      //  cpt code 99458 tables rows value
      const code99458 =  (
        <tr>
          <td>{codeModel.cpt99458 && codeModel.cpt99458.length > 0 ? _.map(codeModel.cpt99458, (value, index) => ( <Badge color="warning" pill outline key={index} className="mr-2"> 99458 </Badge> ))  : '-'}</td>
          <td>{totalSessionRPM}</td>
          <td>{codeModel && _.size(codeModel.cpt99458) > 0 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
        </tr>
      );
      //  cpt code 99439 tables rows value
      const code99439 =  (
        <tr>
          <td>{codeModel.cpt99439 && codeModel.cpt99439.length > 0 ? _.map(codeModel.cpt99439, (value, index) => ( <Badge color="warning" pill outline key={index} className="mr-2"> 99439 </Badge> ))  : '-'}</td>
          <td>{totalSessionCCM}</td>
          <td>{codeModel && _.size(codeModel.cpt99439) > 0 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
        </tr>
      );
    return (
      <div>
      {CPTCodeDetails.isEligible99453 && (
      <div className="scrollbar-table-cls">
      <hr style={{ borderTop: "3px solid #5c5959" }} />
      <table className="table table-bordered page-break-ka-after mb-4">
      <thead>
        <tr>
          <th colSpan="5" className="text-center text-dark">
            <h3 className="font-weight-bold">
            Billing Requirements for CPT Code 99453
            </h3>
          </th>
        </tr>
        {code99453 && (
          <tr>
            <th className="text-center">Subject</th>
            <th className="text-center">Note</th>
            <th className="text-center">Created By</th>
            <th className="text-center">Date</th>
            <th className="text-center">Status</th>
          </tr>
        )}
      </thead>
      <tbody className="text-center">
        {code99453 && code99453.length > 0 ? (
          code99453
        ) : (
          <tr>
            <th
              colSpan="4"
              className="text-black text-danger text-center mx-auto"
            >
              No Record Found
            </th>
            <th
            className="text-black text-danger text-center mx-auto"
            >
            {CPTCodeDetails.isEligible99453 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}
            </th>
          </tr>
        )}
        <tr>
        <th colSpan="5" className="text-center text-dark">
        <h6 className="font-weight-bold text-primary">
        First Month date that we billed for 99454 : {CPTCodeDetails.firstEligible99453 ? moment(CPTCodeDetails.firstEligible99453).format("MM/DD/YYYY") : '-'}
        </h6>
        </th>
        </tr>
      </tbody>
      </table>
      </div>
      )}
      {CPTCodeDetails && CPTCodeDetails.isEligible99445 && (
        <div>
          <hr style={{ borderTop: "3px solid #5c5959" }} />
          <table className="table table-bordered page-break-ka-after mb-4">
            <thead>
              <tr>
                <th colSpan="2" className="text-center text-dark">
                  <h3 className="font-weight-bold">
                    Billing Requirements for CPT Code 99445
                  </h3>
                </th>
              </tr>
              {code99445 && (
                <tr>
                  <th className="text-center">Adherence Days</th>
                  <th className="text-center">Status</th>
                </tr>
              )}
            </thead>
            <tbody className="text-center">
              {code99445 ? (
                code99445
              ) : (
                <tr>
                  <th
                    colSpan="2"
                    className="text-black text-danger text-center mx-auto"
                  >
                    No Record Found
                  </th>
                </tr>
              )}
            </tbody>
          </table>
      </div>)}
      {CPTCodeDetails && CPTCodeDetails.isEligible99454 && (
      <div className="scrollbar-table-cls"> 
     <hr style={{ borderTop: "3px solid #5c5959" }} />
     <table className="table table-bordered page-break-ka-after mb-4">
      <thead>
        <tr>
          <th colSpan="2" className="text-center text-dark">
            <h3 className="font-weight-bold">
            Billing Requirements for CPT Code 99454
            </h3>
          </th>
        </tr>
        {code99454 && (
          <tr>
            <th className="text-center">Adherence Days</th>
            <th className="text-center">Status</th>
          </tr>
        )}
      </thead>
      <tbody className="text-center">
        {code99454 ? (
          code99454
        ) : (
          <tr>
            <th
              colSpan="2"
              className="text-black text-danger text-center mx-auto"
            >
              No Record Found
            </th>
          </tr>
        )}
      </tbody>
    </table>
    </div>)}
    {codeModel && _.size(codeModel.cpt99457) > 0 &&
    <div className="scrollbar-table-cls">
    <hr style={{ borderTop: "3px solid #5c5959" }} />
    <table className="table table-bordered page-break-ka-after mb-4">
    <thead>
      <tr>
        <th colSpan="2" className="text-center text-dark">
          <h3 className="font-weight-bold">
          Billing Requirements for CPT Code 99457
          </h3>
        </th>
      </tr>
    </thead>
    <tbody>
    <tr>
    <SessionNotes
    notes={rpmMode}
    pmMode={"RPM MODE"}
    pmModeTotal={totalSessionRPM}
    />
    <td className="text-center">{codeModel && _.size(codeModel.cpt99457) > 0 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
    </tr>
    </tbody>
    </table>
    <table className="table table-bordered mb-4" style={{ fontSize: "13px" }}>
      <tbody>
        <tr>
          <th style={{ width: "30%", backgroundColor: "#f9f9f9" }}>Called</th>
          <td>{CPTCodeDetails.isCalled ? "Yes" : "No"}</td>
        </tr>
        <tr>
          <th style={{ width: "30%", backgroundColor: "#f9f9f9" }}>Monthly Phone Consultation By</th>
          <td>{getPatientMonthlyPhoneConsultationBy({ monthlyPhoneConsultationBy: CPTCodeDetails.monthlyPhoneConsultationBy, ccmLogs: rpmMode }) || "-"}</td>
        </tr>
      </tbody>
    </table>
    </div>
    }
    {codeModel && _.size(codeModel.cpt99470) > 0 && (<div>
    <hr style={{ borderTop: "3px solid #5c5959" }} />
    <table className="table table-bordered page-break-ka-after mb-4">
    <thead>
      <tr>
        <th colSpan="3" className="text-center text-dark">
          <h3 className="font-weight-bold">
          Billing Requirements for CPT Code 99470
          </h3>
        </th>
      </tr>
      <tr>
      <th className="text-center">Billing Requirements for CPT Code 99470</th>
      <th className="text-center">Total RPM Time</th>
      <th className="text-center">Status</th>
    </tr>
    </thead>
    <tbody className="text-center">
        {code99470 ? (
          code99470
        ) : (
          <tr>
            <th
              colSpan="3"
              className="text-black text-danger text-center mx-auto"
            >
              No Record Found
            </th>
          </tr>
        )}
    </tbody>
    </table>
    </div>)}
    {codeModel && _.size(codeModel.cpt99458) > 0 && (<div>
    <hr style={{ borderTop: "3px solid #5c5959" }} />
    <table className="table table-bordered page-break-ka-after mb-4 scrollbar-table-cls">
    <thead>
      <tr>
        <th colSpan="3" className="text-center text-dark">
          <h3 className="font-weight-bold">
          Billing Requirements for CPT Code 99458
          </h3>
        </th>
      </tr>
      <tr>
      <th className="text-center">Billing Requirements for CPT Code 99458</th>
      <th className="text-center">Total RPM Time</th>
      <th className="text-center">Status</th>
    </tr>
    </thead>
    <tbody className="text-center">
        {code99458 ? (
          code99458
        ) : (
          <tr>
            <th
              colSpan="3"
              className="text-black text-danger text-center mx-auto"
            >
              No Record Found
            </th>
          </tr>
        )}
    </tbody>
    </table>
    </div>)}
    {codeModel && _.size(codeModel.cpt99490) > 0 && (
      <div> 
    <hr style={{ borderTop: "3px solid #5c5959" }} />
    <table className="table table-bordered page-break-ka-after mb-4 scrollbar-table-cls">
    <thead>
      <tr>
        <th colSpan="2" className="text-center text-dark">
          <h3 className="font-weight-bold">
          Billing Requirements for CPT Code 99490 
          </h3>
        </th>
      </tr>
    </thead>
    <tbody>
    <tr>
    <SessionNotes 
    notes={ccmMode}
    pmMode={"CCM MODE"}
    pmModeTotal={totalSessionCCM}
    />
    <td className="text-center">{codeModel && _.size(codeModel.cpt99490) > 0 ? <Badge color="success" pill outline> MET </Badge> : <Badge color="danger" pill outline> NOT MET </Badge>}</td>
    </tr>
    </tbody>
    </table>
    </div>)}
    {code99439 && _.size(codeModel.cpt99439) > 0 && (<div>
    <hr style={{ borderTop: "3px solid #5c5959" }} />
    <table className="table table-bordered page-break-ka-after mb-4 scrollbar-table-cls">
    <thead>
      <tr>
        <th colSpan="3" className="text-center text-dark">
          <h3 className="font-weight-bold">
          Billing Requirements for CPT Code 99439
          </h3>
        </th>
      </tr>
      <tr>
      <th className="text-center">Billing Requirements for CPT Code 99439</th>
      <th className="text-center">Total RPM Time</th>
      <th className="text-center">Status</th>
    </tr>
    </thead>
    <tbody className="text-center">
        {code99439 ? (
          code99439
        ) : (
          <tr>
            <th
              colSpan="3"
              className="text-black text-danger text-center mx-auto"
            >
              No Record Found
            </th>
          </tr>
        )}
    </tbody>
    </table>
    </div>)}
    </div>
    );    
}
  
export default CPTCodeList;